export default function firestoreExists(doc) {
  if (typeof doc.exists === "function") {
    return doc.exists();
  } else if (typeof doc.exists === "boolean") {
    return doc.exists;
  }
}
